/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { LizardUnitsEnum } from "./LizardUnitsEnum";
import {
  LizardUnitsEnumFromJSON,
  LizardUnitsEnumFromJSONTyped,
  LizardUnitsEnumToJSON,
  LizardUnitsEnumToJSONTyped,
} from "./LizardUnitsEnum";

/**
 * Mixin for validating "offset" and "duration"
 * Assumes simulation to be present on Serializer
 * @export
 * @interface PatchedLizardTimeseriesSourcesSinks
 */
export interface PatchedLizardTimeseriesSourcesSinks {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  duration?: number | null;
  /**
   *
   */
  referenceUuid?: string;
  /**
   *
   */
  startDatetime?: Date;
  /**
   *
   */
  interpolate?: boolean;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
  /**
   *
   */
  multiplier?: number;
  /**
   *
   */
  units?: LizardUnitsEnum;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  readonly values?: Array<Array<number>>;
}

/**
 * Check if a given object implements the PatchedLizardTimeseriesSourcesSinks interface.
 */
export function instanceOfPatchedLizardTimeseriesSourcesSinks(
  value: object
): value is PatchedLizardTimeseriesSourcesSinks {
  return true;
}

export function PatchedLizardTimeseriesSourcesSinksFromJSON(
  json: any
): PatchedLizardTimeseriesSourcesSinks {
  return PatchedLizardTimeseriesSourcesSinksFromJSONTyped(json, false);
}

export function PatchedLizardTimeseriesSourcesSinksFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedLizardTimeseriesSourcesSinks {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"] == null ? undefined : json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    referenceUuid: json["reference_uuid"] == null ? undefined : json["reference_uuid"],
    startDatetime:
      json["start_datetime"] == null ? undefined : parseDateTime(json["start_datetime"]),
    interpolate: json["interpolate"] == null ? undefined : json["interpolate"],
    uid: json["uid"] == null ? undefined : json["uid"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
    multiplier: json["multiplier"] == null ? undefined : json["multiplier"],
    units: json["units"] == null ? undefined : LizardUnitsEnumFromJSON(json["units"]),
    values: json["values"] == null ? undefined : json["values"],
  };
}

export function PatchedLizardTimeseriesSourcesSinksToJSON(
  json: any
): PatchedLizardTimeseriesSourcesSinks {
  return PatchedLizardTimeseriesSourcesSinksToJSONTyped(json, false);
}

export function PatchedLizardTimeseriesSourcesSinksToJSONTyped(
  value?: Omit<PatchedLizardTimeseriesSourcesSinks, "url" | "simulation" | "uid" | "values"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    reference_uuid: value["referenceUuid"],
    start_datetime:
      value["startDatetime"] == null
        ? value["startDatetime"]
        : serializeDateTime(value["startDatetime"]),
    interpolate: value["interpolate"],
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
    multiplier: value["multiplier"],
    units: LizardUnitsEnumToJSON(value["units"]),
  };
}
